import videoJs from 'video.js';

export default function VideoRenderer({ placeholders }) {
  // manually initialise videoJs on each video element
  placeholders.forEach(p => videoJs(p));

  return null;
}
